<div class="cmdb-export-container" *ngIf="!isLoadingLabels">
	<span class="title">{{ labels.lbl_extracao_dados_cmdb }}</span>

	<span class="label">{{ labels.lbl_rep_custom_nome }}:</span>
	<input (input)="reportName = $event.target.value" [value]="reportName" />
	<pcp-cmdb-search-filter
		(getSelectedFilters)="selectedFilters = $event"
		[selectedFilters]="this.selectedFilters"
		[searchCis]="false"
		[hideFilters]="['substatus']"
		[multiOptionSelect]="true">
	</pcp-cmdb-search-filter>

	<div class="button-container">
		<div class="button" [ngClass]="{ disabled: selectedFilters && selectedFilters.length === 0 }" (click)="copyToClipboard()">
			{{ labels.lbl_copiar_area_transferencia }}
		</div>
		<div class="button" (click)="saveReport()">{{ labels.lbl_geral_salvar }}</div>
		<div class="button" (click)="exportSavedReport()">{{ labels.lbl_geral_exportar_excel }}</div>
	</div>

	<div class="saved-export-container">
		<span class="label">{{ labels.lbl_relatorios_salvos }}</span>
		<div class="saved-export-item" *ngFor="let report of savedReports; let index = index">
			<span>{{ report.name }}</span>
			<div>
				<span [title]="labels.lbl_ckp_deletar_este_indicador"
					><fa-icon [icon]="icons.faTrash" (click)="removeSavedReport(index)"></fa-icon
				></span>
				<span [title]="labels.lbl_copiar_area_transferencia"
					><fa-icon [icon]="icons.faCopy" (click)="copyToClipboard(index)"></fa-icon
				></span>
				<span [title]="labels.lbl_geral_exportar_excel"
					><fa-icon [icon]="icons.faFileExport" (click)="exportSavedReport(index)"></fa-icon
				></span>
			</div>
		</div>
	</div>
	<span *ngIf="savedReports && savedReports.length === 0">{{ labels.lbl_report_no_report }}</span>
</div>

<div class="loading-container" *ngIf="isLoadingLabels">
	<cpi-svg-gears></cpi-svg-gears>
	<div>{{ labels.lbl_edocs_carregando }}!</div>
</div>
